import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // 首页
  {
    path: '*',
    name: 'Home',
    // 路由懒加载：https://router.vuejs.org/zh/guide/advanced/lazy-loading.html
    // webpackPreload：https://www.jianshu.com/p/bbdcfeee7fbc
    component: () => import(/* webpackPreload: true */ '@/views/home'),
    meta: {
      title: '首页',
      showTab: true,
      keepAlive: true
    }
  },
  // 登录
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/login'),
    meta: {
      title: '登录'
    }
  },
  // 注册
  {
    path: '/registry',
    name: 'Registry',
    component: () => import('@/views/auth/login'),
    meta: {
      title: '注册'
    }
  },
  // 下载
  {
    path: '/download',
    name: 'Download',
    component: () => import('@/views/download/Download'),
    meta: {
      title: '科路驰'
    }
  },
  // 分类
  {
    path: '/category',
    name: 'Category',
    component: () => import('@/views/category'),
    meta: {
      title: '分类',
      showTab: false,
      keepAlive: false
    }
  },
  // 购物车
  {
    path: '/cart',
    name: 'Cart',
    component: () => import('@/views/cart'),
    meta: {
      title: '购物车',
      showTab: true
    }
  },
  // 我的
  {
    path: '/user',
    name: 'User',
    component: () => import('@/views/user'),
    meta: {
      title: '我的',
      showTab: true
    }
  },
  // 用户设置
  {
    path: '/userSetting',
    name: 'UserSetting',
    component: () => import('@/views/userSetting'),
    meta: {
      title: '用户设置',
      showTab: false
    }
  },
  // 用户设置-昵称
  {
    path: '/userSetting/nickname',
    name: 'UserSetNickname',
    component: () => import('@/views/userSetting/nickname'),
    meta: {
      title: '设置昵称',
      showTab: false
    }
  },
  // 用户设置-生日
  {
    path: '/userSetting/birthday',
    name: 'UserSetBirthday',
    component: () => import('@/views/userSetting/birthday'),
    meta: {
      title: '设置生日',
      showTab: false
    }
  },
  // 用户设置-性别
  {
    path: '/userSetting/gender',
    name: 'UserSetGender',
    component: () => import('@/views/userSetting/gender'),
    meta: {
      title: '设置性别',
      showTab: false
    }
  },
  // 用户设置-邮箱
  {
    path: '/userSetting/email',
    name: 'UserSetEmail',
    component: () => import('@/views/userSetting/email'),
    meta: {
      title: '设置邮箱',
      showTab: false
    }
  },
  // 用户设置-手机
  {
    path: '/userSetting/mobile',
    name: 'UserSetMobile',
    component: () => import('@/views/userSetting/mobile'),
    meta: {
      title: '设置手机号',
      showTab: false
    }
  },
  // 用户设置-密码
  {
    path: '/userSetting/password',
    name: 'UserSetPassword',
    component: () => import('@/views/userSetting/password'),
    meta: {
      title: '设置密码',
      showTab: false
    }
  },
  // 订单列表
  {
    path: '/user/order/list/:active',
    name: 'OrderList',
    props: true,
    component: () => import('@/views/order/list'),
    meta: {
      title: '订单列表',
      showTab: false
    }
  },
  // 商品列表
  {
    path: '/product/:categoryLevel/:cateId',
    name: 'Product',
    props: true,
    component: () => import('@/views/product'),
    meta: {
      title: '商品列表',
      keepAlive: true
    }
  },
  // 金刚位跳转商品列表
  {
    path: '/diamondGoodsList/:diamondId',
    name: 'Diamand',
    props: true,
    component: () => import('@/views/diamondGoodsList'),
    meta: {
      title: '商品列表',
      keepAlive: true
    }
  },
  // 商品详情
  {
    path: '/detail/:goodsId',
    name: 'Detail',
    props: true,
    component: () => import('@/views/detail'),
    meta: {
      title: '商品详情',
      keepAlive: true
    }
  },
  // 商品评论
  {
    path: '/detail/comment/:goodsId/:tagType',
    name: 'Comment',
    props: true,
    component: () => import('@/views/detail/comment'),
    meta: {
      title: '商品评论'
    }
  },
  // 地址管理
  {
    path: '/address',
    name: 'Address',
    component: () => import('@/views/address/list'),
    meta: {
      title: '地址管理'
    }
  },
  // 科路驰iot
  {
    path: '/iot',
    name: 'Iot',
    component: () => import('@/views/iot'),
    meta: {
      title: '物联',
      showTab: false
    }
  },
  // 蘑菇房
  {
    path: '/mush',
    name: 'Mush',
    component: () => import('@/views/mush'),
    meta: {
      title: '方舱',
      showTab: false
    }
  },
  // 待处理报警
  {
    path: '/mush/warning',
    name: 'Warning',
    component: () => import('@/views/mush/warning'),
    meta: {
      title: '待处理报警',
      showTab: false
    }
  },
  // 设置参数
  {
    path: '/mush/settings',
    name: 'Settings',
    component: () => import('@/views/mush/settings'),
    meta: {
      title: '设置参数',
      showTab: false
    }
  },
  // 蘑菇房统计页面
  {
    path: '/mush/count',
    name: 'Count',
    component: () => import('@/views/mush/count'),
    meta: {
      title: '数据统计',
      showTab: false
    }
  },
  // 蘑菇房视频监控页面
  {
    path: '/mush/video',
    name: 'Video',
    component: () => import('@/views/mush/video'),
    meta: {
      title: '视频监控',
      showTab: false
    }
  },
  // 新方舱（mushNew）
  {
    path: '/mushnew',
    name: 'MushNew',
    component: () => import('@/views/mushNew'),
    meta: {
      title: '新方舱',
      showTab: false
    }
  },
  // 新方舱待处理报警
  {
    path: '/mushnew/warning',
    name: 'MushNewWarning',
    component: () => import('@/views/mushNew/warning'),
    meta: {
      title: '待处理报警',
      showTab: false
    }
  },
  // 新方舱设置参数
  {
    path: '/mushnew/settings',
    name: 'MushNewSettings',
    component: () => import('@/views/mushNew/settings'),
    meta: {
      title: '设置参数',
      showTab: false
    }
  },
  // 新方舱统计页面
  {
    path: '/mushnew/count',
    name: 'MushNewCount',
    component: () => import('@/views/mushNew/count'),
    meta: {
      title: '数据统计',
      showTab: false
    }
  },
  // 新方舱视频监控页面
  {
    path: '/mushnew/video',
    name: 'MushNewVideo',
    component: () => import('@/views/mushNew/video'),
    meta: {
      title: '视频监控',
      showTab: false
    }
  },
  // 科路驰服务
  {
    path: '/server',
    name: 'Server',
    component: () => import('@/views/server'),
    meta: {
      title: '服务',
      showTab: true
    }
  },
  // 添加服务地址
  {
    path: '/addServerAddress',
    name: 'AddServerAddress',
    component: () => import('@/views/server/servers/AddServerAddress'),
    meta: {
      title: '管理服务地址',
      showTab: false
    }
  },
  // 服务项
  {
    path: '/serverItem',
    name: 'ServerItem',
    component: () => import('@/views/server/servers/ServiceTabs'),
    meta: {
      title: '服务'
    }
  },
  // 我的服务
  {
    path: '/myServer',
    name: 'MyServer',
    component: () => import('@/views/server/servers/MyServer'),
    meta: {
      title: '我的服务'
    }
  },
  // 地址编辑
  {
    path: '/address/edit',
    name: 'AddressEdit',
    component: () => import('@/views/address/edit'),
    meta: {
      title: '地址编辑'
    }
  },
  // 搜索
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/search'),
    meta: {
      title: '搜索'
    }
  },
  // 搜索结果
  {
    path: '/search/list',
    name: 'SearchList',
    component: () => import('@/views/search/list'),
    meta: {
      title: '搜索结果'
    }
  },
  // 确认订单
  {
    path: '/order/confirm',
    name: 'OrderConfirm',
    component: () => import('@/views/order/confirm'),
    meta: {
      title: '确认订单',
      keepAlive: true
    }
  },
  // 订单支付
  {
    path: '/order/pay',
    name: 'OrderPay',
    component: () => import('@/views/order/pay'),
    meta: {
      title: '订单支付'
    }
  },
  // 订单详情
  {
    path: '/order/detail/:orderSn',
    name: 'OrderDetail',
    props: true,
    component: () => import('@/views/order/detail'),
    meta: {
      title: '订单详情'
    }
  },
  // 支付状态
  {
    path: '/order/payStatus',
    name: 'PayStatus',
    props: true,
    component: () => import('@/views/order/payStatus')
  },
  // 优惠券
  {
    path: '/order/coupon',
    name: 'coupon',
    component: () => import('@/views/order/coupon'),
    meta: {
      title: '优惠券',
      showTab: false
    }
  },
  // 优惠券
  {
    path: '/order/my',
    name: 'couponMy',
    component: () => import('@/views/order/my'),
    meta: {
      title: '优惠券',
      showTab: false
    }
  },
  // 评论页面
  {
    path: '/goodsComment/:orderGoodsId/:goodsId',
    name: 'GoodsComment',
    props: true,
    component: () => import('@/views/goodsComment'),
    meta: {
      title: '商品评论'
    }
  },
  // 协议页面
  {
    path: '/agreement',
    name: 'Agreement',
    component: () => import('@/views/agreement/index'),
    meta: {
      title: '协议'
    }
  },
  // 家电回收
  {
    path: '/recycling',
    name: 'Recycling',
    component: () => import('@/views/server/servers/Recycling.vue'),
    meta: {
      title: '家电回收'
    }
  },
  // 家电回收提交记录
  {
    path: '/recycling-record',
    name: 'RecyclingRecord',
    component: () => import('@/views/server/servers/RecyclingRecord.vue'),
    meta: {
      title: '家电回收提交记录'
    }
  },
  // 自助查询
  {
    path: '/self-query',
    name: 'SelfQuery',
    component: () => import('@/views/server/servers/SelfQuery.vue'),
    meta: {
      title: '自助查询'
    }
  },
  // 自助详情
  {
    path: '/server/self-detail',
    name: 'SelfDetail',
    component: () => import('@/views/server/servers/SelfDetail.vue')
  }
]

const router = new VueRouter({
  // 记录上个页面的滚动位置
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
})

export default router
